import { BID_STATUSES, BidRequestStatus, CompanyRole, QUOTE_SELECTION_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { getRoleMapping } from "utils";

import { QUOTE_SELECTION } from "utils/envConstants";
import { STATUS_FILTERS_MAPPING, STATUS_FILTERS_TOOLTIP } from "./filersUtils";
import { FilterTabs } from "ui";

export const StatusFilters = observer(() => {
  const { pendingActionsBidList, pendingStatistics, user } = useStores();
  const { isCustomer } = user.roles;

  const hasQuoteSelectionCustomer = QUOTE_SELECTION === QUOTE_SELECTION_ENUM.CUSTOMER && isCustomer;

  const allowedStatuses = STATUS_FILTERS_MAPPING[getRoleMapping(user.scope) as CompanyRole] || [];

  const relevantStatusTexts = Object.entries(BID_STATUSES.texts)
    .filter(([key]) => allowedStatuses.includes(key as BidRequestStatus))
    .reduce(
      (acc, [key, value]) => {
        acc[key as BidRequestStatus] = value;
        return acc;
      },
      {} as Record<BidRequestStatus, string>
    );

  const role = getRoleMapping(user.scope) as CompanyRole;
  const tooltips = STATUS_FILTERS_TOOLTIP[role];

  const options = Object.keys(relevantStatusTexts)
    .filter((key) => (!hasQuoteSelectionCustomer ? true : key !== "QUOTE_PROPOSED"))
    .map((key) => ({
      value: key as BidRequestStatus,
      label: relevantStatusTexts[key as BidRequestStatus],
      tooltip: tooltips?.[key as BidRequestStatus],
      count: pendingStatistics.indicators.requests?.[key],
    }));

  const currentFilterStatus = pendingActionsBidList.queryParams?.status?.[0] || undefined;

  const handleChange = (value: BidRequestStatus | undefined) => {
    pendingActionsBidList.onChangeDataFlow({
      filters: { status: value !== undefined ? [value] : [] },
      sorters: pendingActionsBidList.sorters,
    });
  };

  return (
    <FilterTabs<BidRequestStatus | undefined>
      options={options}
      currentValue={currentFilterStatus}
      onChange={handleChange}
    />
  );
});
